/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */

import {
  Card,
  CardPreview,
  CardFooter,
} from '@fluentui/react-components/unstable';
import { Image, Text, Button, mergeClasses } from '@fluentui/react-components';
import { Delete20Regular } from '@fluentui/react-icons';
import { getFlexRowStyles, getFlexItemStyles } from '../styles/layouts';
import { useState } from 'react';

export const MediaCard = ({
  mediaItem,
  nowPlayingId,
  sharingActive,
  buttonText,
  selectMedia,
  removeMediaItem,
}) => {
  const flexRowStyle = getFlexRowStyles();
  const flexItemStyles = getFlexItemStyles();

  const [short, setShort] = useState(true);

  const handleChangeShort = () => {
    setShort(!short);
  };

  let shortDescription = null;
  if (mediaItem.content[0].description) {
    shortDescription =
      mediaItem.content[0].description.substring(0, 55) + '...';
  }

  return (
    <div className={flexItemStyles.noShrink} style={{ padding: 5 }}>
      <Card
        appearance="filled"
        style={{
          padding: '0rem',
          minHeight: '0px',
          minWidth: '0px',
          width: '100%',
          height: '100%',
          margin: '0rem',
          cursor: 'default',
          border: 'none',
        }}
      >
        <CardPreview
          style={{
            minHeight: '0px',
            maxHeight: '140px',
            overflow: 'hidden',
          }}
        >
          <Image
            height={140}
            fit="contain"
            src={mediaItem.thumbnail_url}
            style={{ minHeight: '0px' }}
          />
        </CardPreview>
        <div
          style={{
            minHeight: '0px',
            paddingLeft: '0.6rem',
            paddingRight: '0.6rem',
          }}
        >
          <Text
            weight="semibold"
            style={{ fontFamily: 'RecoletaAlt', fontWeight: 500, fontSize: 15 }}
          >
            {mediaItem.title}
          </Text>
          <br></br>
          <Text size={200} weight="light" style={{ fontFamily: 'SofiaPro', marginBottom: 5, display: 'inline-block' }}>
            with <b>{mediaItem.presenter_name}</b>
          </Text>
          <br></br>
          <Text
            weight="light"
            style={{ fontFamily: 'SofiaPro', fontWeight: 300, fontSize: '13px', lineHeight: 1 }}
          >
            {short ? shortDescription : mediaItem.content[0].description}&nbsp;
          </Text>
          {shortDescription && (
            <div
              onClick={() => handleChangeShort()}
              style={{ color: 'lightcyan', display: 'inline-block' }}
            >
              <Text size={200} weight="light" style={{ fontFamily: 'RecoletaAlt' }}>
                {short ? 'Read More' : 'Read Less'}
              </Text>
            </div>
          )}
        </div>
        <CardFooter
          styles={{
            padding: '0rem',
            minHeight: '0px',
            minWidth: '0px',
          }}
        >
          <div
            className={mergeClasses(
              flexRowStyle.root,
              flexRowStyle.vAlignCenter
            )}
            style={{
              width: '100%',
              paddingLeft: '0.6rem',
              paddingRight: '0.6rem',
              paddingBottom: '0.6rem',
              paddingTop: '0rem',
            }}
          >
            <div className={flexItemStyles.grow}>
              <Button
                appearance="outline"
                size="small"
                disabled={nowPlayingId === mediaItem.id && sharingActive}
                onClick={() => {
                  selectMedia(mediaItem);
                }}
                style={{ fontFamily: 'SofiaPro' }}
              >
                {buttonText}
              </Button>
            </div>
            {!!removeMediaItem && (
              <Button
                appearance="subtle"
                size="small"
                icon={<Delete20Regular />}
                title={'Remove from playlist'}
                onClick={() => {
                  removeMediaItem(mediaItem.id);
                }}
              />
            )}
          </div>
        </CardFooter>
      </Card>
    </div>
  );
};
